export const OUT_OF_STOCK_FORM = 'js-out-of-stock-form';
export const OUT_OF_STOCK_SECTION = 'js-out-of-stock-section';
export const OUT_OF_STOCK_SUCCESS = 'js-out-of-stock-success';
export const OUT_OF_STOCK_INPUT = 'js-out-of-stock-input';
export const OUT_OF_STOCK_BUTTON = 'js-out-of-stock-button';
